import React, { useEffect, useState } from "react";
import "../assets/css/creditors.css";
import Title from "../components/Title";
import { useSelector } from "react-redux";
import { FaFilter, FaTimes } from "react-icons/fa";

const Creditors = () => {
  const { user } = useSelector((state) => state.user);
  //
  const [data1, setData1] = useState([]);
  const [data2, setData2] = useState([]);
  useEffect(() => {
    if (user !== null) {
      setData1(user.Other_Debt_Details);
      setData2(user.Other_Debt_Details);
    }
  }, [user]);
  //
  const [searchInput, setSearchInput] = useState("");
  const filterData = () => {
    const filtered = data1.filter((item) => {
      const creditorName = item?.Creditors_Name?.name
        ?.toLowerCase()
        .includes(searchInput.toLowerCase());

      const lanMatch = item?.Loan_Account_Number?.toString()
        .toLowerCase()
        .includes(searchInput.toLowerCase());

      const bankTypeMatch =
        filterInputs.bankType === "" ||
        item?.Bank_Type?.toLowerCase() === filterInputs.bankType;

      const loanTypeMatch =
        filterInputs.loanType === "" ||
        item?.Loan_Type?.toLowerCase() === filterInputs.loanType;

      const accountStatusMatch =
        filterInputs.accountStatus === "" ||
        item?.Account_Status1?.toLowerCase() === filterInputs.accountStatus;

      return (
        (creditorName || lanMatch) &&
        bankTypeMatch &&
        loanTypeMatch &&
        accountStatusMatch
      );
    });

    setData2(filtered);
    setModalVisible(false);
  };
  const resetSearchFilter = () => {
    setSearchInput("");
    setFilterInputs({
      bankType: "",
      loanType: "",
      accountStatus: "",
    });
    setModalVisible(false);
    setData2(data1);
  };

  useEffect(() => {
    filterData();
  }, [searchInput, data1]);
  //
  const [filterInputs, setFilterInputs] = useState({
    bankType: "",
    loanType: "",
    accountStatus: "",
  });
  const handleFilterInputs = (e) => {
    const { name, value } = e.target;
    setFilterInputs({
      ...filterInputs,
      [name]: value,
    });
  };
  const [modalVisible, setModalVisible] = useState(false);
  const openModal = () => {
    setModalVisible(true);
  };
  const closeModal = () => {
    setModalVisible(false);
  };
  return (
    <>
      <div className="payments-container">
        <div className="d-flex justify-content-between gap-2 flex-sm-row flex-column">
          <Title title="Tickets" />
          <div className="filter-flex">
            <input
              type="text"
              className="input"
              placeholder="Search..."
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
            />
            <button className="button" onClick={openModal}>
              <FaFilter />
            </button>
          </div>
        </div>
        <hr />
        <div className="project-table-overflow">
          <>
            {data2.length === 0 ? (
              <p className="text-center">No data found</p>
            ) : (
              <table className="project-table creditors-table">
                <thead>
                  <tr>
                    <th>Sr</th>
                    <th>Creditor's Name</th>
                    <th>Account Number</th>
                    <th>Bank Type</th>
                    <th>Loan Type</th>
                    <th>Account Status</th>
                    <th>Balance OS</th>
                    <th>Actual settlement</th>
                    <th>Settlement date</th>
                    <th>Settlement waiver</th>
                  </tr>
                </thead>
                <tbody>
                  {data2.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.Creditors_Name?.name || "-"}</td>
                        <td>{item.Loan_Account_Number || "-"}</td>
                        <td>{item.Bank_Type || "-"}</td>
                        <td>{item.Loan_Type || "-"}</td>
                        <td>{item.Account_Status1 || "-"}</td>
                        <td>{item.Balance_O_S || "-"}</td>
                        <td>{item.Actual_Settlement || "-"}</td>
                        <td>{item.Settlement_Date || "-"}</td>
                        <td>{item.Settlement_Waiver || "-"}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </>
        </div>
      </div>

      <div
        className={`modal-background ${modalVisible ? "active" : ""}`}
        style={{ zIndex: "100" }}
      >
        <div className="modal-container">
          <div className="d-flex align-items-end justify-content-between">
            <h2>Filter</h2>
            <button className="red-button" onClick={closeModal}>
              <FaTimes />
            </button>
          </div>
          {/*  */}
          <hr />
          <div>
            <div className="mt-4">
              <p className="mb-2">Bank type</p>
              <select
                className="input"
                name="bankType"
                value={filterInputs.bankType}
                onChange={handleFilterInputs}
              >
                <option value="">Select</option>
                <option value="app loan">App loan</option>
                <option value="bank">Bank</option>
              </select>
            </div>
            <div className="mt-4">
              <p className="mb-2">Loan type</p>
              <select
                className="input"
                name="loanType"
                value={filterInputs.loanType}
                onChange={handleFilterInputs}
              >
                <option value="">Select</option>
                <option value="Personal Loan">Personal Loan</option>
                <option value="Credit Card">Credit Card</option>
                <option value="Home loan">Home loan</option>
                <option value="Unsecured Overdraft">Unsecured Overdraft</option>
                <option value="Unsecured Business Loan">
                  Unsecured Business Loan
                </option>
                <option value="Business Loan">Business Loan</option>
                <option value="Car Loan">Car Loan</option>
                <option value="Overdraft">Overdraft</option>
                <option value="Consumer Loan">Consumer Loan</option>
              </select>
            </div>
            <div className="mt-4">
              <p className="mb-2">Account status</p>
              <select
                className="input"
                name="accountStatus"
                value={filterInputs.accountStatus}
                onChange={handleFilterInputs}
              >
                <option value="">Select</option>
                <option value="Active">Active</option>
                <option value="Settlement">Settlement</option>
                <option value="Settled">Settled</option>
              </select>
            </div>
          </div>
          <div className="d-flex align-content-center justify-content-end gap-2 mt-4">
            <button
              className="red-button"
              onClick={resetSearchFilter}
              style={{ width: "90px" }}
            >
              Reset
            </button>
            <button
              className="button"
              onClick={filterData}
              style={{ width: "90px" }}
            >
              Apply
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Creditors;
